<template>
    <CustomTable title="Чек-листы" :rowsData="this.rowsData" :columns="checkListsTableColumns" :stickyHeader="true"
        :loading="isFetching" :custom-body="true" :small="true" :height="250" :showHeaderAdd="true"
        :on-add-click="addNewItem">
        <template #customBody="props" v-if="!isFetching">
            <q-tr>
                <custom-table-cell align="center" vertical-align="center">
                    {{ props.row.check_list_id }}
                </custom-table-cell>

                <custom-table-cell align="left" vertical-align="center">
                    <input v-if="editingId === props.row.check_list_id" v-model="editForm.check_name"
                        class="form-control" type="text" required />
                    <span v-else>{{ props.row.check_name }}</span>
                </custom-table-cell>

                <custom-table-cell align="center" vertical-align="center" style="width: 150px;">
                    <input v-if="editingId === props.row.check_list_id" v-model="editForm.is_active" type="checkbox" />
                    <span v-else>{{ props.row.is_active === 1 ? 'Да' : 'Нет' }}</span>
                </custom-table-cell>

                <custom-table-cell align="center" vertical-align="center">
                    <input v-if="editingId === props.row.check_list_id" v-model="editForm.norm" class="form-control"
                        type="text" />
                    <span v-else>{{ props.row.norm }}</span>
                </custom-table-cell>

                <custom-table-cell align="center" vertical-align="center" style="width: 150px;">
                    <div class="action-buttons">
                        <CustomButton class="action-button" v-if="editingId === props.row.check_list_id"
                            @click="saveItem" :disabled="saving" color="success" outlined
                            style="width: auto; height: auto;">
                            <q-icon name="check" size="16px" />
                        </CustomButton>
                        <CustomButton class="action-button" v-if="editingId === props.row.check_list_id"
                            @click="cancelEdit" color="negative" style="width: auto; height: auto;">
                            <q-icon name="close" size="16px" />
                        </CustomButton>
                        <CustomButton class="action-button" v-else @click="editItem(props.row)" color="primary-light"
                            style="width: auto; height: auto;">
                            <q-icon name="edit" size="16px" />
                        </CustomButton>
                    </div>
                </custom-table-cell>

                <custom-table-cell align="center" vertical-align="center">
                    <CustomIcon icon="trash" :approve-mode="true" :loading="!!deleteLoading[props.row.check_list_id]"
                        :approve="() => onDeleteSubmit(props.row.check_list_id)" />
                </custom-table-cell>
            </q-tr>
        </template>
    </CustomTable>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import {
    getCheckListsList,
    checkListsTableColumns,
    updateCheckList,
    deleteCheckList,
} from "@/views/CheckLists/services";
import CustomDropdown from "@/components/common/CustomDropdown";
import CustomButton from "@/components/common/CustomButton.vue";
import CustomIcon from "@/components/common/CustomIcon";

export default {
    name: "CheckLists",
    components: { CustomTableCell, CustomTable, CustomDropdown, CustomButton, CustomIcon },
    data() {
        return {
            checkListsTableColumns,
            rowsData: [],
            totalRecords: 0,
            isFetching: false,
            activeWorkSetId: null,
            bindCheckListsDrawerOpen: false,
            saving: false,
            editingId: null,
            editForm: {
                check_list_id: null,
                check_name: "",
                is_active: false,
                norm: "",
            },
            deleteLoading: {},
        }
    },
    methods: {
        getActionsDropdown() {
            return [
                { label: 'Привязать чек-листы', action: 'bindCheckLists' },
            ]
        },
        handleAction(action, row) {
            if (action.action === 'bindCheckLists') {
                this.openBindCheckListsDrawer(row.work_set_id)
            }
        },
        openBindCheckListsDrawer(work_set_id) {
            this.activeWorkSetId = work_set_id
            this.bindCheckListsDrawerOpen = true
        },
        async getData() {
            this.isFetching = true
            const res = await getCheckListsList()
            if (!res) return;
            this.isFetching = false
            this.rowsData = res || []
        },
        refetch() {
            this.getData();
        },
        editItem(item) {
            this.editingId = item.check_list_id;
            this.editForm = {
                check_list_id: item.check_list_id,
                check_name: item.check_name || "",
                is_active: item.is_active === 1,
                norm: item.norm || "",
            };
        },
        addNewItem() {
            if (this.editingId !== null) {
                return;
            }

            const newItem = {
                check_list_id: 0,
                check_name: "",
                is_active: false,
                norm: "",
            };
            this.rowsData.unshift(newItem);
            this.editItem(newItem);
        },
        async saveItem() {
            if (!this.editForm.check_name?.trim()) {
                this.$q.notify({
                    type: 'negative',
                    message: 'Наименование чек-листа обязательно для заполнения'
                });
                return;
            }

            this.saving = true;
            const body = {
                check_list_id: this.editForm.check_list_id === 0 ? null : this.editForm.check_list_id,
                check_name: this.editForm.check_name,
                is_active: this.editForm.is_active ? 1 : 0,
                norm: this.editForm.norm || null,
            };
            const result = await updateCheckList(body);
            this.saving = false;
            if (!result) return;
            await this.getData();
            this.editingId = null;
            this.resetEditForm();
        },
        cancelEdit() {
            if (this.editForm.check_list_id === 0) {
                this.rowsData = this.rowsData.filter(item => item.check_list_id !== 0);
            }
            this.editingId = null;
            this.resetEditForm();
        },
        resetEditForm() {
            this.editForm = {
                check_list_id: null,
                check_name: "",
                is_active: false,
                norm: "",
            };
        },
        async onDeleteSubmit(check_list_id) {
            if (this.deleteLoading[check_list_id]) return;
            this.deleteLoading = { ...this.deleteLoading, [check_list_id]: true };
            const res = await deleteCheckList(check_list_id);
            this.deleteLoading = { ...this.deleteLoading, [check_list_id]: false };
            if (!res) return;
            this.rowsData = this.rowsData.filter(row => row.check_list_id !== check_list_id);
        },
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped lang="scss">
.form-control {
    width: 100%;
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.action-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
}
</style>